import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Typography, Button } from "@material-ui/core";

export default props => {
    return (
        <>
            <Modal isOpen={props.isOpen}>
                <ModalHeader>Add Qualification</ModalHeader>
                <ModalBody>
                    <Typography variant="body2">
                        Add qualification
                        <b>
                            {" "}
                            {props.qualification.qualification_title}
                        </b> to <b>assigned</b> qualifications for <b>all</b>{" "}
                        users?{" "}
                    </Typography>
                </ModalBody>
                <ModalFooter>
                    <Button
                        onClick={() => props.setModalState(false, false)}
                        variant="contained"
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={() => {
                            props.addQualification(props.qualification);
                            props.setModalState(false, false);
                        }}
                        variant="contained"
                        color="primary"
                    >
                        Add
                    </Button>
                </ModalFooter>{" "}
            </Modal>
        </>
    );
};
